import { createRoutine } from 'redux-saga-routines';

const setFiles = createRoutine('UPLOAD_FILES');

export default {
  setFiles,
};
